import { createAction, props } from '@ngrx/store';
import { IIdValuePair } from 'src/app/core/interfaces/common/common/id-value-pair.interface';

export const INVOICE_AMOUNT = '[FinancialProfile] InvoiceAmount';
export const INVOICE_TERM = '[FinancialProfile] InvoiceTerm';
export const BANK_STATEMENTS_COMPLETE =
  '[FinancialProfile] BankStatementsComplete';
export const BALANCE_SHEETS_COMPLETE =
  '[FinancialProfile] BalanceSheetsComplete';
export const PL_STATEMENTS_COMPLETE = '[FinancialProfile] PlStatementsComplete';
export const AR_AGING_COMPLETE = '[FinancialProfile] ArAgingComplete';
export const AP_AGING_COMPLETE = '[FinancialProfile] ApAgingComplete';
export const ALL = '[FinancialProfile] All';

export const InvoiceAmountAction = createAction(
  INVOICE_AMOUNT,
  props<{
    invoiceAmount: IIdValuePair;
  }>()
);

export const InvoiceTermAction = createAction(
  INVOICE_TERM,
  props<{
    invoiceTerm: IIdValuePair;
  }>()
);

export const BankStatementsCompleteAction = createAction(
  BANK_STATEMENTS_COMPLETE,
  props<{
    bankStatementsComplete: boolean;
  }>()
);

export const BalanceSheetsCompleteAction = createAction(
  BALANCE_SHEETS_COMPLETE,
  props<{
    balanceSheetsComplete: boolean;
  }>()
);

export const PlStatementsCompleteAction = createAction(
  PL_STATEMENTS_COMPLETE,
  props<{
    plStatementsComplete: boolean;
  }>()
);

export const ArAgingCompleteAction = createAction(
  AR_AGING_COMPLETE,
  props<{
    arAgingComplete: boolean;
  }>()
);

export const ApAgingCompleteAction = createAction(
  AP_AGING_COMPLETE,
  props<{
    apAgingComplete: boolean;
  }>()
);

export const AllAction = createAction(
  ALL,
  props<{
    invoiceAmount: IIdValuePair;
    invoiceTerm: IIdValuePair;
    bankStatementsComplete: boolean;
    balanceSheetsComplete: boolean;
    plStatementsComplete: boolean;
    arAgingComplete: boolean;
    apAgingComplete: boolean;
  }>()
);

export type All =
  | ReturnType<typeof InvoiceAmountAction>
  | ReturnType<typeof InvoiceTermAction>
  | ReturnType<typeof BankStatementsCompleteAction>
  | ReturnType<typeof BalanceSheetsCompleteAction>
  | ReturnType<typeof PlStatementsCompleteAction>
  | ReturnType<typeof ArAgingCompleteAction>
  | ReturnType<typeof ApAgingCompleteAction>
  | ReturnType<typeof AllAction>;
